import { importLibrary } from '@googlemaps/js-api-loader';
import type { Nullable } from '@iheartjane/types';

import { formatGeocodeResponse } from './geocoderHelpers';
import type { GeocodingResult, LatLong } from './types';

type ReverseGeocodeParams = {
  /** Initializer stub that replaces the v1 JS api loader. This should be a function that sets the Google API options. */
  loader: () => void;
  /** The GPS coordinates to look up. */
  searchCriteria: LatLong;
};

/**
 * Given GPS coordinates, retrieve a human-readable address (as a parsed Geocoding result).
 */
export const reverseGeocode = async ({
  loader,
  searchCriteria,
}: ReverseGeocodeParams): Promise<Nullable<GeocodingResult>> => {
  loader();

  const { Geocoder } = await importLibrary('geocoding');
  const { LatLng } = await importLibrary('core');
  const geocoder = new Geocoder();

  return new Promise((resolve) => {
    geocoder.geocode(
      {
        location: new LatLng(searchCriteria.lat, searchCriteria.long),
      },
      (results) => {
        const firstResult = results?.[0];
        resolve(firstResult ? formatGeocodeResponse(firstResult) : null);
      }
    );
  });
};
